import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';

//PAGES
import { ViewEntregaPage } from '../view-entrega/view-entrega';

//PROVIDERS
import { Services, Tools } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-pedido',
  templateUrl: 'pedido.html',
})
export class PedidoPage {
  pedido:any;
  entrega:any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl:AlertController,
    private services: Services,
    private tools: Tools
  ) {
    this.pedido = this.navParams.get('item').pedido;
    this.entrega = this.navParams.get('item').entrega;
  }

  ionViewDidLoad(){
    this.pedido = this.navParams.get('item').pedido;
    this.entrega = this.navParams.get('item').entrega;
  }

  checkin(){
    var loading = this.tools.showLoading('Carregando...');
    loading.present();
    this.pedido.entrega.checkin = new Date().getTime();
    this.services.save('cadPedidos',this.pedido,(result)=>{
      loading.dismiss();
      this.tools.showAlert('toast','Check-In registrado com sucesso.');
    });
  }

  ocorrencia(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Qual o motivo da ocorrência?');

    let list = ['Cliente cancelou','Caminhão quebrado','Acidente','Cliente ausente','Outros'];
    for(var x1 of list){
      alert.addInput({type:'radio', label:x1, value:x1, checked:false});
    }

    // alert.addInput({type:'text', value:'', placeholder: 'Placeholder 1'});
    alert.addButton({
      text: 'Cancelar',
      handler: causa => {
        return;
      }
    });

    alert.addButton({
      text: 'OK',
      handler: causa => {
        if(!causa){
          this.tools.showAlert('toast','Selecione o motivo da ocorrência.');
          this.ocorrencia();return;
        }
        this.pedido.entrega.status = 'Ocorrência';
        this.pedido.entrega.ocorrencia = causa+'';

        if(this.pedido.entrega.inicioEntrega == 0){
          this.pedido.entrega.inicioEntrega == new Date().getTime();
        }

        this.services.save('cadPedidos',this.pedido,(result)=>{
          this.tools.showAlert('toast','Ocorrência registrada com sucesso.');
          this.navCtrl.push(ViewEntregaPage,{item:this.entrega});
        });
      }
    });

    alert.present();
  }

  openWaze(){
    window.open('geo:0,0?q='+this.pedido.position.lat+','+this.pedido.position.lng, '_system');
  }
}



// WEBPACK FOOTER //
// ./src/pages/pedido/pedido.ts